function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const UsersIcon = _ref => {
  let {
    size,
    bg,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.363s-6.182 0-8.5 5.41c0 0 3.871 1.545 8.5 1.545s8.5-1.545 8.5-1.545c-2.318-5.41-8.5-5.41-8.5-5.41zm0-.771c2.318 0 3.863-2.318 3.863-6.183S15 3.545 15 3.545s-3.863 0-3.863 3.864 1.545 6.183 3.863 6.183zm-7.5-2.637c.762 0 1.416-.316 1.935-.885a11.114 11.114 0 0 1-.298-2.661c0-1.485.571-2.396 1.274-2.958C9.645 2.686 7.5 2.682 7.5 2.682s-3.182 0-3.182 3.182 1.273 5.091 3.182 5.091zm3 2.494l-.108-1.258c-1.558-.596-2.892-.6-2.892-.6s-5.091 0-7 4.455c0 0 2.461.981 5.645 1.22 2.773-2.903 4.355-3.817 4.355-3.817z"
  }));
};
UsersIcon.defaultProps = {
  size: 16,
  bg: 'currentColor'
};
export default UsersIcon;